// sso登录地址
const loginUrl = 'https://sso.100tal.com/portal/login';
// const loginUrl = 'https://sso.chengjiukehu.com/portal/login';

// sso登出地址
const logoutUrl = 'https://sso.100tal.com/sso/logout';
// const logoutUrl = 'https://sso.chengjiukehu.com/sso/logout';
// appid
const appId = import.meta.env.VITE_SSO_APPID;
/**
 * 拼接SSO登录地址
 * SSO文档
 * https://doc-openapi.zhiyinlou.com/doc#/sso/scenes
 */
export function getSSOLoginUrl(customParams: Record<string, string> = {}): string {
  // 获取当前的路由地址
  let redirectUrl = window.location.href;
  if (redirectUrl.includes('offline')) {
    redirectUrl = redirectUrl.replace('offline', 'goodsManage');
  }
  if (redirectUrl.includes('exception/401')) {
    redirectUrl = redirectUrl.replace('exception/401', 'goodsManage');
  }
  const paramsAll = { sso_to_pc_view: 1, ...customParams, redirect: redirectUrl };
  const paramKeys = Object.keys(paramsAll || {});
  const paramsString = paramKeys.map((k) => `${k}=${paramsAll[k]}`).join('&');
  const params = paramKeys.length > 0 ? `?${paramsString}` : '';
  return `${loginUrl}/${appId}${params}`;
}

/**
 * 生成 sso 退出登录地址
 * @description
 * 技术文档 https://doc-openapi.zhiyinlou.com/doc#/sso/logout
 * @param {string} redirectUrl 退出成功后重定向地址
 * @returns {string}
 */
export function getSSOLogoutUrl(redirectUrl = ''): string {
  const redirect = redirectUrl || getSSOLoginUrl();
  return `${logoutUrl}?path=${encodeURIComponent(redirect)}`;
}
